// prettier-ignore
import { configureStore } from "@reduxjs/toolkit";
import {
  apiTokenReducer,
  assetCategoryReducer,
  assetTypeReducer,
  basicReducer,
  connectionTypeReducer,
  customAccountReducer,
  externalAppIntegrationReducer,
  // ===========================================================================================
  // ================================== Setup ================================================
  // ===========================================================================================
  integationMasterReducer,
  integrationAWSReducer,
  integrationCheckReducer,
  integrationMcpReducer,
  integrationOAuthReducer,
  integrationReducer,
  integrationServiceReducer,
  // ===========================================================================================
  // ================================== Landing ================================================
  // ===========================================================================================
  myProjectReducer,
  oAuthReducer,
  serviceReducer,
  userRoleReducer
} from "@slice";

// ===========================================================================================
export const store = configureStore({
  reducer: {
    // ===========================================================================================
    // ================================== Platform Config ========================================
    // ===========================================================================================
    integration: integrationReducer,
    integrationService: integrationServiceReducer,
    assetCategory: assetCategoryReducer,
    assetType: assetTypeReducer,
    integrationCheck: integrationCheckReducer,
    connectionType: connectionTypeReducer,
    integrationMcp: integrationMcpReducer,
    integrationOAuth: integrationOAuthReducer,
    userRole: userRoleReducer,
    customAccount: customAccountReducer,

    // ===========================================================================================
    // ================================== Landing ================================================
    // ===========================================================================================
    myProject: myProjectReducer,
    service: serviceReducer,
    apiToken: apiTokenReducer,
    basic: basicReducer,
    oAuth: oAuthReducer,
    integrationAWS: integrationAWSReducer,
    externalAppIntegration: externalAppIntegrationReducer,

    // ===========================================================================================
    // ================================== Setup ================================================
    // ===========================================================================================
    integrationMaster: integationMasterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
